<template>
  <div :class="classNames">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      label-position="left"
    >
		<el-form-item label="选择账号:" prop="warrant_id">
		  <div :class="classNames + '_from_item_con'">
			<el-select v-model="ruleForm.warrant_id" placeholder="请选择授权账号">
			  <el-option v-for="(item, i) in groupAuthList" :key="item.id"
          :label="item.name" :value="item.id" >
        </el-option>
			</el-select>
		  </div>
		</el-form-item>
		<el-form-item label="群聊类型:" prop="group_type">
		  <div :class="classNames + '_from_item_con'">
			<el-radio-group v-model="ruleForm.group_type">
			  <el-radio label="2">
				  主播粉丝群
				  <el-tooltip popper-class="create_group_tooltip" effect="dark" content="需要用户通过实名认证；需要用户有开播纪录" placement="top-start">
					<i class="el-icon-question"></i>
				  </el-tooltip>
				</el-radio>
			  <el-radio label="5">
				  万粉群
				  <el-tooltip popper-class="create_group_tooltip" effect="dark" content="需要用户粉丝量过万" placement="top-start">
					<i class="el-icon-question"></i>
				  </el-tooltip>
			  </el-radio>
			</el-radio-group>
		  </div>
		</el-form-item>
		<el-form-item label="进群审批:" prop="open_audit_switch">
		  <div :class="classNames + '_from_item_con'">
			<el-radio-group v-model="ruleForm.open_audit_switch">
			  <el-radio :label="2">
			  	自动审批
			  	<el-tooltip popper-class="create_group_tooltip" effect="dark" content="学员购买课程后，才可以进群" placement="top-start">
			  	  <i class="el-icon-question"></i>
			  	</el-tooltip>
			  </el-radio>
			  <!-- <el-radio :label="1">
			  	手动审批
			  	<el-tooltip popper-class="create_group_tooltip" effect="dark" content="讲师后台审核后，学员才可以进群" placement="top-start">
			  	  <i class="el-icon-question"></i>
			  	</el-tooltip>
			  </el-radio> -->
			  <el-radio :label="0">
				关闭
				<el-tooltip popper-class="create_group_tooltip" effect="dark" content="不需要任何条件，学员都可以进群" placement="top-start">
				  <i class="el-icon-question"></i>
				</el-tooltip>
			  </el-radio>
			</el-radio-group>
		  </div>
		</el-form-item>
      <el-form-item label="群名称:" prop="group_name">
        <div :class="classNames + '_from_item_con'">
          <el-input placeholder="请输入群名称" v-model="ruleForm.group_name" maxlength="20" show-word-limit/>
        </div>
      </el-form-item>
	  <el-form-item label="群头像:" prop="avatar">
	  	<div :class="classNames + '_from_item_con'">
	  		<div :class="classNames + '_disabled'"></div>
	  		<uploader-img :boxH="100" :boxW="100" :ratio="[1,1]" size="200*200" v-model="ruleForm.avatar"
	  		:cropperW="200" :cropperH="200"
	  			id="avatar" dialogWidth="800px"></uploader-img>
	  	</div>
	  </el-form-item>
	  <el-form-item label="群聊简介:" prop="group_desc">
	    <div :class="classNames + '_from_item_con'">
	        <el-input
	        type="textarea"
	        :rows="3"
	        placeholder="请输入群描述"
	        maxlength="50"
	        show-word-limit
	        v-model="ruleForm.group_desc">
	        </el-input>
	    </div>
	  </el-form-item>
	  
	  
      <el-form-item label="关联课程:" prop="product_ids">
        <div :class="classNames + '_from_item_con'">
			<!-- <el-radio-group v-model="ruleForm.course_scope">
			    <el-radio :label="1">全部课程</el-radio>
			</el-radio-group> -->
             <el-button type="primary" @click="visible=true">关联课程</el-button>
        </div>
      </el-form-item>
      
      <el-form-item>
        <div :class="[classNames + '_operat', classNames + '_from_item_con']">
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="goBack">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
	
    <groupClass v-model="visible" @sure="sureClass"></groupClass>
	
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import uploaderImg from '@/components/upload/upload.vue'
import groupClass from './groupClass.vue'
export default {
  name: "CreateChapter",
  data() {
    return {
      classNames: "CreateChapter",
      visible: false,
      ruleForm: {
        warrant_id: '',
      group_type: '',
      open_audit_switch: 2,
      group_name: '',
	  course_scope: 2,
      product_ids: [],
      group_desc: '',
		avatar: ''
      },
      rules: {
        product_ids: [
          {
            type: 'array',
            required: true,
            message: "添加课程",
            trigger: "change",
          },
        ],
        warrant_id: [
			{
			  required: true,
			  message: "请选择授权账号",
			  trigger: "change",
			},
		],
		open_audit_switch: [
			{
			  required: true,
			  message: "请选择审核方式",
			  trigger: "change",
			},
		],
		group_type: [
			{
			  required: true,
			  message: "请选择群聊类型",
			  trigger: "change",
			},
		],
        group_name: [
          {
            required: true,
            message: "请输入群名称",
            trigger: "change",
          },
        ],
      group_desc: [
        {
          required: true,
            message: "请输入群简介",
            trigger: "change",
        }
      ],
		avatar: [
		  {
		    required: true,
		    message: "请上传群聊头像",
		  },
		]
      },
	  dyAuthCode: '',
    groupAuthList: [],
    };
  },
  components: {
    groupClass,
	'uploader-img': uploaderImg,
  },
  created() {
    this.getGroupAuthInfo()
  },
  computed: {
    ...mapState(["breadCrumbList"]),
  },
  methods: {
    ...mapActions("groupChat", ["dyGroupAdd", 'groupAuthInfo']),
    submitForm(formName) {
      console.log(this.ruleForm)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
            console.log(this.ruleForm, '...params')
        	try {
                let res = await this.dyGroupAdd(this.ruleForm)
                this.$message({
                  type: 'success',
                  message: '提交成功'
                })
                this.$router.go(-1)
                } catch (error) {
                    
                }
        } else {
        	console.log('error submit!!');
        	this.$message.closeAll()
        	this.messageOption = this.$message({
        		message: '有必填项没有填写或格式错误',
        		showClose: true,
        		duration: 0,
        		type: 'error'
        	})
        	return false;
        }
      })
    },
    goBack() {
        this.$router.go(-1)
    },
    sureClass(data) {
      this.ruleForm.product_ids = data.map(item => item.id)
    },
  editAvatarUrl() {
    this.$refs.uploaderImg.dialogVisible = true
  },
  async changeFile() {
    try {
      if(type == 'avatar') {
        localStorage.setItem('avatar_url', this.userInfo.avatar_url)
      }
    } catch (error) {
      
    }
  },
    // 获取已授权列表
    async getGroupAuthInfo() {
      try{
        const author_id = localStorage.getItem('id')
        let res = await this.groupAuthInfo({author_id: author_id})
        this.groupAuthList = res.available || []
      }catch(e){
        this.groupAuthList = []
      }
    },
  },
  watch: {},
  beforeDestroy() {
    if (this.messageOption) {
      this.messageOption.close();
    }
    this.messageOption = "";
  },
};
</script>
<style lang="less">
@classNames: CreateChapter;
.market_date_picker {
    .el-picker-panel__footer {
        display: flex;
        justify-content: space-between;
        padding-left: 16px;
        padding-right: 16px;
        .el-button {
            &:nth-child(2) {
                background-color: #409eff;
                border-color: #409eff;
                color: #fff;
            }
            &.is-disabled {
                background-color: #fff;
                border-color: #ebeef5;
                color: #c0c4cc;
            }
        }
    }
}
.el-radio__label{
	position: relative;
	.el-icon-question{
		font-size: 22px;
		position: absolute;
		top: -50%;
		right: -22px;
		color: rgb(215, 215, 215)!important;
	}
}
.create_group_tooltip{
	transform: translate(2px, 6px)!important;
}
</style>
<style lang="less" scoped>
@classNames: CreateChapter;
.@{classNames} {
  max-width: 660px;
  // margin: 0 auto;
  // position: relative;
  .@{classNames}_from_item_con {
    width: 300px;
    display: inline-block;
    position: relative;
  }
}
.@{classNames}_from_item_tit {
  margin-left: 20px;
}
.@{classNames}_operat {
  display: flex !important;
  justify-content: flex-end;
}
.@{classNames}_class_content {
  .@{classNames}_radio {
    display: flex;
    flex-direction: column;
    position: relative;
    left: 20px;

    .el-radio {
      &:not(:first-child) {
        margin-top: 20px;
      }
    }
  }
}
.@{classNames}_add_con {
  .@{classNames}_tit {
    font-size: 14px;
    color: #37383c;
    line-height: 20px;
    margin-bottom: 10px;
    font-weight: 550;
  }
  .@{classNames}_add_class_info {
    width: 660px;
    height: 80px;
    background: #f8f9fb;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .@{classNames}_add_class_left {
      width: 60px;
      height: 45px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .@{classNames}_add_class_center {
      width: 410px;
      height: 100%;
      color: #6a6c76;
      word-break: break-all;
      line-height: normal;
    }
    .@{classNames}_add_class_right {
      font-size: 14px;
      line-height: 20px;
      color: #409eff;
      cursor: pointer;
    }
  }
}

.basicInfo_user_img {
			width: 100px;
			height: 100px;
			margin-right: 20px;
			border-radius: 50%;
			position: relative;
			overflow: hidden;
			.edit_img {
				position: absolute;
				left: 0;
				bottom: 0px;
				width: 100%;
				background-color: rgba(0,0,0,.5);
				height: 30px;
				color: #fff;
				z-index: 99;
				text-align: center;
				line-height: 30px;
				transition: .5s;
				font-size: 12px;
				transform: translateY(100%);
				cursor: pointer;
				.iconfont {
					margin-right: 2px;
				}
			}
			&:hover .edit_img {
				transform: translateY(0%);
			}
		}
</style>
